import { useState } from "react";
import { PREP_MAX_MINUTES, PREP_MIN_MINUTES, PREP_QUICK_OPTIONS } from "../lib/types";

interface Props {
  orderNumber: string;
  busy: boolean;
  onConfirm: (prepMinutes: number) => void;
  onCancel: () => void;
}

// Prep-Time-Eingabe. Werte innerhalb der Backend-Grenzen (5..180); das
// Backend validiert zusätzlich (INVALID_PREP_TIME).
export function AcceptDialog({ orderNumber, busy, onConfirm, onCancel }: Props) {
  const [minutes, setMinutes] = useState<number>(15);
  const valid = Number.isFinite(minutes) && minutes >= PREP_MIN_MINUTES && minutes <= PREP_MAX_MINUTES;

  return (
    <div className="dialog-backdrop" role="dialog" aria-modal="true" aria-label={`Bestellung ${orderNumber} annehmen`}>
      <div className="dialog">
        <h2>Bestellung #{orderNumber} annehmen</h2>
        <p>Zubereitungszeit wählen ({PREP_MIN_MINUTES}–{PREP_MAX_MINUTES} min):</p>
        <div className="chip-row">
          {PREP_QUICK_OPTIONS.map((m) => (
            <button key={m} type="button" className={`chip ${minutes === m ? "chip--active" : ""}`} onClick={() => setMinutes(m)}>
              {m} min
            </button>
          ))}
        </div>
        <label className="field">
          <span>Eigene Zeit (min)</span>
          <input
            type="number"
            min={PREP_MIN_MINUTES}
            max={PREP_MAX_MINUTES}
            value={Number.isFinite(minutes) ? minutes : ""}
            onChange={(e) => setMinutes(parseInt(e.target.value, 10))}
          />
        </label>
        {!valid && <p className="hint hint--warn">Bitte eine Zeit zwischen {PREP_MIN_MINUTES} und {PREP_MAX_MINUTES} Minuten wählen.</p>}
        <div className="dialog__actions">
          <button className="btn" onClick={onCancel} disabled={busy}>Abbrechen</button>
          <button className="btn btn--primary" onClick={() => onConfirm(minutes)} disabled={busy || !valid}>
            Annehmen ({minutes} min)
          </button>
        </div>
      </div>
    </div>
  );
}
